import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorage } from '../../shared/services/local-storage.service';
import { hasProfileContext } from './guard.utils';

/**
 * Auth Guard - Functional guard using modern Angular patterns
 * Protects routes by checking for valid authentication token
 * 
 * @param route - Activated route snapshot
 * @param state - Router state snapshot
 * @returns true if user is authenticated, false otherwise (redirects to login)
 */
export const authGuard: CanActivateFn = () => {
    const localStorageService = inject(LocalStorage);
    const router = inject(Router);

    const accessToken = localStorageService.getDataByKey('accessToken');

    if (accessToken && !hasProfileContext(localStorageService)) {
        console.warn('Missing profile context. Redirecting to login page.');
        localStorageService.clearAllStorage();
        return router.parseUrl('/');
    }

    if (accessToken) {
        // User is authenticated, allow access to protected routes
        return true;
    }

    // User is not authenticated, redirect to login page
    console.warn('Authentication required. Redirecting to login page.');
    return router.parseUrl('/');
};
